export default "__VITE_ASSET__BIqvZZhl__"